import {
	KActionDialog,
	KDataTable,
	KDataTableMenu
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";
import { formatCurrency } from "kinnect-formatters";

export default KDataTable.extend( {
	name: "KPurchaseOrdersErrorsTable",

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no purchase order errors to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching purchase order errors found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "purchaseOrderNumbers"
		}
	},

	computed: {
		canEditPurchaseOrders() {
			return this.$can( "edit_purchase_orders" );
		},

		defaultHeaders() {
			return [
				{
					text: "Associated PO#",
					value: "purchaseOrderNumbers"
				},
				{
					text: "Error Type(s)",
					value: "errorTypeNames"
				},
				{
					text: "Error Notes",
					value: "error"
				},
				{
					text: "Error Cost",
					value: "cost"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteError( purchaseOrderError ) {
			const deleteIndex = this.items.findIndex( item => purchaseOrderError.id === item.id );

			return purchaseOrderError
			.delete()
			.then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.cost": ( { item } ) => (
					item.cost
						? formatCurrency( item.cost )
						: "--"
				),

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "salesPurchaseOrderError",
								params: { idError: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canEditPurchaseOrders && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete purchase order error" )}
								onConfirm={() => this.deleteError( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete Purchase Order Error"
							>
								Are you sure you want to delete the purchase order error with the description <strong>{item.error}</strong>?
							</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
